module.exports = __webpack_public_path__ + "img/2.b3834a45.png";